import { Button, Tooltip } from "@forge/common";
import "./button.scss";
import { btnResponsive, textResponsive } from "../../utils/helper";

const ButtonComponent = ({
  title,
  className = "",
  disabled = false,
  tooltip,
  iconButton = false,
  inverseTheme = false,
  ...props
}: any) => {
  const button = (
    <Button
      className={`${disabled ? "button-option-disabled" : ""} ${iconButton ? textResponsive() : btnResponsive()} ${className}`}
      disabled={disabled}
      {...props}
    >
      {title}
    </Button>
  );

  return tooltip && !disabled ? (
    <Tooltip
      content={tooltip}
      position="bottom"
      inverseTheme={inverseTheme}
      className="text-[#303030] text-sm"
      focusableAnchor
    >
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default ButtonComponent;
